import Component from '@glimmer/component';
import groupBy from 'nightwatch-web/utils/group-by';

export default class FilterPresetsComponent extends Component {
  get filterPresetsByGroup() {
    return groupBy(this.args.filterPresets, 'group');
  }
}
